import React from 'react';

import { ChangeHandler } from 'src/presentation/components/pages/integrations/types';
import CompactSection from 'src/presentation/components/pages/integrations/editorComponents/CompactSection';
import { Row } from 'src/presentation/components/forms/Layout';
import {
  MaskedField,
  WrappedField,
} from 'src/presentation/components/pages/integrations/editorComponents/EditorFields';

function renderYotpoConfiguration(onChange: (attr: string) => ChangeHandler): JSX.Element {
  return (
    <>
      <CompactSection
        description={`Yotpo is an eCommerce marketing platform with solutions for customer reviews, visual marketing, loyalty, referrals, and SMS marketing.`}
      >
        <Row>
          <WrappedField
            attr="name"
            label="Name"
            placeholder="App Name"
            description="This is the name that will be displayed throughout Gladly"
            data-aid="yotpo-integration-name"
            autoFocus={true}
            onChange={onChange('name')}
          />
        </Row>
        <CompactSection
          header="Authentication"
          description={`Passwords and keys used to connect to other accounts are treated as secrets in Gladly.
               If you need to change an existing secret, use the clear button in the field to remove the current
               secret and enter a new one`}
        >
          <Row>
            <MaskedField
              attr="secrets.token"
              label="Yotpo Access Token"
              showClearButton={false}
              isMasked={true}
              readOnly={true}
              data-aid="yotpo-token"
              onChange={onChange('secrets.token')}
            />
          </Row>
        </CompactSection>
      </CompactSection>
    </>
  );
}

export default renderYotpoConfiguration;
